import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
// import ForgotPassword from "./ForgotPassword";
import { isAuthenticated } from "../helpers/authUtils";
//import LuminateLogo from "assets/images/JBU.png";
import StAlbertLogo from "assets/images/StAlbertLogo.png";
//import LuminateLogo from "assets/images/BACOHT.png";
// var LuminateLogo = "https://sidmach.com/wp-content/uploads/2024/02/sidmach-logo-A.png";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  hideMessage,
  showAuthLoader,
  applicantSignIn,
  updateUsermode,
} from "actions/Auth";

import Header from "./Header";

class ApplicantSignin extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
    };
  }
  componentDidMount() {
    this.props.updateUsermode("Applicant");
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 400);
    }
    if (isAuthenticated(this.props.authUser)) {
      this.props.history.push("/applicant/dashboard");
    }
  }
  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 400);
    }
    if (isAuthenticated(this.props.authUser)) {
      this.props.history.push("/applicant/dashboard");
    }
  }

  render() {
    const { email, password } = this.state;
    const { showMessage, loader, alertMessage } = this.props;
    return (
      <>
        {/* <div>
          <Link to="/">HOME &#x1F3E0;</Link>
        </div> */}
        <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
          <div className="app-login-main-content">
            <div
              className="app-logo-content d-flex align-items-center justify-content-center"
              style={{
                // backgroundColor: "white",
                backgroundColor: "#B78E2D",
                // backgroundColor: "#007FFF",
                padding: "10px 15px 10px 10px", // Slightly more padding on the right
                borderRadius: "4px",
                // marginLeft: "-px",
              }}
            >
              <Link className="logo-lg" to="../" title="Luminate">
                <img
                  src={StAlbertLogo}
                  alt="StAlbertLogo"
                  title="StAlbertLogo"
                  className="img-fluid"
                />
              </Link>
            </div>

            <div className="app-login-content">
              <div className="app-login-header mb-4">
                <h1>Applicant Login</h1>
                <h6
                  className="d-flex align-items-center justify-content-center p-1"
                  style={{ color: "#B78E2D" }}
                >
                  {" "}
                  Applicants can login with their email address Or Jamb Reg No
                  and password sent to their email
                </h6>
              </div>

              <div className="app-login-form">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.props.showAuthLoader();
                    this.props.applicantSignIn({ email, password });
                  }}
                >
                  <fieldset>
                    <TextField
                      label={<IntlMessages id="Email Or JambRegNo" />}
                      variant="outlined"
                      size="small"
                      fullWidth
                      onChange={(event) =>
                        this.setState({ email: event.target.value })
                      }
                      defaultValue={email}
                      margin="normal"
                      // type="email"
                      className="mt-1 my-sm-3"
                      required
                    />
                    <TextField
                      type="password"
                      label={<IntlMessages id="appModule.password" />}
                      variant="outlined"
                      size="small"
                      fullWidth
                      onChange={(event) =>
                        this.setState({ password: event.target.value })
                      }
                      defaultValue={password}
                      margin="normal"
                      className="mt-1 my-sm-3"
                      required
                    />

                    <div className="mb-3 d-flex align-items-center justify-content-between">
                      <Button
                        type="submit"
                        variant="contained"
                        // style={{ backgroundColor: "#42a0e3", color: "#ffffff" }}
                        style={{ backgroundColor: "#B78E2D", color: "#ffffff" }}
                      >
                        <IntlMessages id="appModule.signIn" />
                      </Button>

                      <Link to="./ForgotPassword">
                      <IntlMessages id="appModule.forgotPassword" />
                    </Link>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
          {loader && (
            <div className="loader-view">
              <CircularProgress />
            </div>
          )}
          {showMessage && NotificationManager.error(alertMessage)}
          <NotificationContainer />
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, applicantUser } = auth;
  const authUser = applicantUser;
  return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps, {
  applicantSignIn,
  hideMessage,
  showAuthLoader,
  updateUsermode,
})(ApplicantSignin);
